// Campus photo for /colleges/cornell-university: CC BY-SA 4.0, by LBM1948, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ACornell_University_Arts_Quad_view%2C_Ithaca%2C_NY_07.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/cornell-university/; credited under the photo.
const photo = {
    "slug": "cornell-university",
    "alt": "McGraw Tower seen past a stone hall and autumn trees on the Arts Quad at Cornell University in Ithaca, New York",
    "src": "/colleges/cornell-university/campus-1600.webp",
    "srcSmall": "/colleges/cornell-university/campus-800.webp",
    "srcMid": "/colleges/cornell-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/cornell-university/og.jpg",
    "title": "Cornell University Arts Quad view, Ithaca, NY 07",
    "author": "LBM1948",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ACornell_University_Arts_Quad_view%2C_Ithaca%2C_NY_07.jpg",
    "read": "2026-10-01"
};

export default photo;
